<template>
    <div id="tools">
        <b-container fluid="sm">
            <b-row>
                <b-col>
                    File
                </b-col>
                <b-col>
                    Hướng dẫn sử dụng
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                  <a target="_blank" href="https://chrome.google.com/webstore/detail/tmproxy-launcher/pmdlifofgdjcolhfjjfkojibiimoahlc"> TM Proxy Chrome Extension</a>
                  <a target="_blank" href="/api/doc/tmclient.rar"> TMProxy Client</a>
                  <a target="_blank" href="https://github.com/tmproxy/csharp-tmproxy">Thư viện DLL tích hợp TM Proxy </a>
                    <a target="_blank" href="/api/doc/tm_proxy_multi_windows.zip"> TM Proxy Multi Client Windows </a>
                    <a target="_blank" href="/api/doc/tm_proxy_multi_linux.zip"> TM Proxy Multi Client Linux</a>
                    <a target="_blank" href="/api/doc/tm_proxy_multi_macos.zip"> TM Proxy Multi Client Mac OS</a>
                </b-col>
                <b-col>
                  <a target="_blank" href="https://youtu.be/vF8drNrjNNM">Hướng dẫn sử dụng TMProxy
                    Client</a>
                    <a target="_blank" href="https://www.youtube.com/watch?v=uFTDkHt5tHI">Hướng dẫn sử dụng TMProxy
                        Client với Google Chrome</a>
                    <a target="_blank" href="https://www.youtube.com/watch?v=Y1TtnGVSnHo">Hướng dẫn sử dụng TMProxy
                        Client với Giả Lập</a>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>

    export default {
        name: "Tools",
        data() {
            return {}
        }
    }
</script>

<style scoped>
    #tools {
        margin-top: 30px;
    }
</style>